import React from 'react'
import { Outlet } from 'react-router-dom'
import PublicNavbar from './PublicNavbar'
import Footer from './Footer'

const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-dark-900">
      <PublicNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default PublicLayout